'use strict';

/**
 * @doc module
 * @name util
 * @description
 *
 * SearchBackend
 */

var app = angular.module('harriApp');


/**
 * Search Backend Factory
 */
app.factory('searchBackend', ['$http', '$q', 'asyncGlobalHandler', 'httpHelper','hEvent', 'positionsDataService', 'hUser',
    function ($http, $q, asyncGlobalHandler, httpHelper, hEvent, positionsDataService, hUser) {

        var data = {
            // 'jobs'          : { 'count': 0 , 'results' : [] },
            // 'mambers'       : { 'count': 0 , 'results' : [] },
            // 'companies'     : { 'count': 0 , 'results' : [] },
        };



        /**
        *
        * Prepare data befor send to API's
        *
        **/

        data.prepareDataBeforeSend = function( type , filterationData ){
            var dataToSend = {};

            var defaultFilteration = {
                'jobs' : 5,
                'big_jobs' : 7,
                'apprentice_jobs' : 5,
                'pride_apprentice_jobs' : 5,
                'big_apprentice_jobs' : 7,
                'members' : 10,
                'big_members' : 14,
                'companies' : 5,
                'big_companies' : 7
            };

            dataToSend.search_phrase = filterationData.search_phrase;

            if( $(window).width() < 1920 ){
              dataToSend.size = filterationData.limitations || defaultFilteration[type];
            }else{
              dataToSend.size = filterationData.limitations || defaultFilteration['big_'+type];
            }

            // Append distance radius value if defined
            if (filterationData.radius) {
                dataToSend.radius = filterationData.radius;
            }

            dataToSend.start = filterationData.offset || 0;
            dataToSend.hecs = filterationData.hecs || [];
            dataToSend.positions = filterationData.positions || [];
            dataToSend.locations = filterationData.locations || [];
            dataToSend.availability = filterationData.availability || [];
            if (filterationData.apprenticeship_type) {
                dataToSend.apprenticeship_type = filterationData.apprenticeship_type;
            }

            if(filterationData.brand_ids){
                dataToSend.brand_ids = filterationData.brand_ids;
            }

            if( dataToSend.positions.length == 0 ){
              dataToSend.categories = filterationData.categories;
            }
            else{
              dataToSend.categories = [];
            }

            dataToSend.cuisines = filterationData.cusine || [];
            dataToSend.skills = filterationData.skills || [];
            dataToSend.degrees = filterationData.degrees || [];

            if (type != 'members' && filterationData.sort && filterationData.sort.length > 0 ) {
                dataToSend.sort = filterationData.sort || [];
                dataToSend.sort_type = filterationData.sort_type || '';
            }

            if (filterationData.apprenticeship_type === 'PRIDE_OF_BRITAIN') {
                dataToSend.postal_code = filterationData.postal_code;
                dataToSend.postal_code_radius = filterationData.postal_code_radius;
                dataToSend.brand_level_ids = filterationData.brand_level_ids;
            }

            if (type == 'members') {

                if (filterationData.experience) {
                    dataToSend.years_of_experience = filterationData.experience
                }

                // Should Removed if Arouri didn't finish it
                if (filterationData.availability) {
                    dataToSend.availability = filterationData.availability;
                }

                if (filterationData.onlyImages || filterationData.onlyImages == undefined ) {
                    dataToSend.has_profile_image = "true";
                }
            }

            var eventData = angular.copy(dataToSend);
            eventData.type = type;
//            hEvent.track('Search', eventData);

            // Tell the API that the source of this search is from the Website.
            dataToSend.source = "web";

            return dataToSend;
        };

        /**
         * Set scope
         *
         * @param scopeRef
         */
        data.setScope = function (scopeRef) {
            data.scope = scopeRef;
        };



        /**
        * get jobs reqarding to the filteration
        * @param filterationData
        **/
        data.getJobs = function( filterationData ){

            filterationData = data.prepareDataBeforeSend( 'jobs' , filterationData );

            var request = httpHelper.p('harri_search/search_jobs',filterationData);
            asyncGlobalHandler.watchPromise(request);
            return { 'type' : 'jobs', 'promise' : request };
        };

        data.getApprenticeJobs = function (filterationData, type) {
            filterationData.apprenticeship_type = 'PRIDE_OF_BRITAIN';
            if (!type) {
                type = 'apprentice_jobs';
                filterationData.apprenticeship_type = 'UKRAINIAN_REFUGEES';
            }
            filterationData = data.prepareDataBeforeSend(type, filterationData);

            var request = httpHelper.p('harri_search/search_jobs',filterationData);
            asyncGlobalHandler.watchPromise(request);
            return {
                'type': type === 'apprentice_jobs' ? 'apprentice_jobs' : 'pride_apprentice_jobs',
                'promise': request
            };
        };

        /**
        * get members reqarding to the filteration
        * @param filterationData
        **/
        data.getMembers = function( filterationData ){

            filterationData = data.prepareDataBeforeSend( 'members' , filterationData );

            //var queryString = "?";
            //
            //for (var i in filterationData) {
            //  if (typeof(filterationData[i]) == 'array') {
            //    queryString += i + '=' + filterationData[i].join(',') + '&';
            //  }
            //  else {
            //    queryString += i + '=' +  filterationData[i] + '&';
            //  }
            //}
            //
            //var request = httpHelper.g('harri_search/search_users' + queryString);

            var request = httpHelper.p('harri_search/search_users', filterationData);
            asyncGlobalHandler.watchPromise(request);
            return { 'type' : 'members', 'promise' : request };
        };

        /**
        * get companies reqarding to the filteration
        * @param filterationData
        **/
        data.getCompanies = function( filterationData ){
            filterationData = data.prepareDataBeforeSend( 'companies' , filterationData );

            var request = httpHelper.p('harri_search/search_brands',filterationData);
            asyncGlobalHandler.watchPromise(request);
            return { 'type' : 'companies', 'promise' : request };
        };



        /**
        * get search promises regarding to the search type on what
        * @param type, params
        **/
        data.searchFor = function( type, params, isLoggedin){


            var returnedData = { 'type' : type , promises : [] };
            switch( type ){

                case 'jobs':
                    returnedData.promises.push( data.getJobs(params) );
                break;

                case 'apprentice_jobs':
                    returnedData.promises.push(data.getApprenticeJobs(params));
                    break;

                case 'pride_apprentice_jobs':
                    returnedData.promises.push(data.getApprenticeJobs(params, 'pride_apprentice_jobs'));
                    break;

                case 'companies' :
                    returnedData.promises.push( data.getCompanies(params) );
                break;

                case 'members' :
                    returnedData.promises.push( data.getMembers(params) );
                break;

                // Search for all
                default:
                    returnedData.promises.push( data.getJobs(params) );
                    returnedData.promises.push( data.getCompanies(params) );
                    if (isLoggedin) {
                        returnedData.promises.push( data.getMembers(params) );
                    }
                break;

            }
            return returnedData;

        };


        /**
         * getFilters
         *
         * @returns {*}
         */
        data.getFilters = function () {
            var defer = $q.defer();
            var promises = [];

            promises.push(httpHelper.g('public_job/getActiveFilters'));

            if(hUser.isLoggedIn()){
                promises.push(httpHelper.getList('degree_lookup', function (obj) {
                    return {
                        name: obj['degree'],
                        id: obj.id
                    };
                }));
            }

            $q.all(promises).then(function (res) {
                var activeFilters = res[0];
                var educationFilter = {
                    'degrees': {
                        'filters': res[1] || [],
                        'title': 'degrees'
                    }
                };

                var mergedResult = $.extend(activeFilters.data.data, educationFilter);

                defer.resolve(mergedResult);
            }).catch(function (err) {
                console.error(err);
            });

            return defer.promise;
        };


        /**
        *
        * getPositionsFilters
        *
        **/
        data.getPositionsFilters = function(){
            var request = positionsDataService.getActivePositions(true);
            asyncGlobalHandler.watchPromise(request);
            return request;
        };

        /**
        *
        * getActivePositionsFilters
        *
        **/
        data.getActivePositionsFilters = function(){
            var request = positionsDataService.getActivePositions();
            asyncGlobalHandler.watchPromise(request);
            return request;
        };


        return data;
    }]);
